import React__default from 'react';
import { getRenderLeaf } from '../../../../core/rendering/getRenderLeaf.mjs';
import { hasMark } from '../../../../core/utilities/nodes/marks/hasMark.mjs';
import { getLeafDeserializer } from '../../../../core/serialization/deserialize/utilities/getLeafDeserializer.mjs';

const Type = 'textcolor';
const TextColorPlugin = _options => ({
  type: Type,
  renderLeaf: getRenderLeaf({
    type: Type,
    rootProps: {},
    component: TextColor
  }),
  serialize: {
    leaf({
      children,
      leaf
    }) {
      if (hasMark(leaf, Type)) {
        return `<span style="color: ${leaf.textcolor}">${children}</span>`;
      }
      return children;
    }
  },
  deserialize: {
    leaf: getLeafDeserializer({
      type: Type,
      node: el => {
        return {
          [Type]: el.style.color
        };
      },
      rules: [{
        nodeNames: ['SPAN'],
        style: ({
          color
        }) => color != null && color !== ''
      }]
    })
  },
  sideEffect: {
    getDerivedAttributes({
      attributes,
      element
    }) {
      const dataColor = element[Type];
      const currentColor = attributes.style != null ? attributes.style.color : undefined;
      const color = dataColor != null ? dataColor : currentColor;
      const colorStyles = color != null ? {
        color
      } : undefined;
      return {
        attributes: {
          style: {
            ...(attributes.style || {}),
            ...colorStyles
          }
        },
        element
      };
    },
    getDerivedDataFromHTML({
      htmlElement,
      data
    }) {
      if (htmlElement.style != null) {
        const color = htmlElement.style.color;
        if (color != null && color !== '') {
          return {
            htmlElement,
            data: {
              ...data,
              [Type]: color
            }
          };
        }
      }
      return {
        htmlElement,
        data
      };
    }
  }
});
function TextColor({
  attributes,
  leaf,
  children
}) {
  const style = {
    color: leaf[Type]
  };
  return /*#__PURE__*/React__default.createElement("span", Object.assign({}, attributes, {
    style: style
  }), children);
}

export { TextColorPlugin, Type };
